import useGameState from "../hooks/useGameState";
import GameTable from "../components/GameTable";
import checkHands from "../utils/checkHands";

const BLIND_LEVELS = [[1, 2], [2, 4], [3, 6], [5, 10], [10, 20], [15, 30], [20, 40], [40, 80]];
const STEP_NAMES = ["Префлоп", "Флоп", "Тёрн", "Ривер"];
const NEXT_STEP_NAMES = ["Флоп", "Тёрн", "Ривер", "Шоудаун"];

function compareHands(a, b) {
  if (a.rank !== b.rank) return a.rank - b.rank;
  for (let i = 0; i < Math.max(a.tiebreak.length, b.tiebreak.length); i++) {
    const av = a.tiebreak[i] ?? -1;
    const bv = b.tiebreak[i] ?? -1;
    if (av !== bv) return av - bv;
  }
  return 0;
}

export default function Game({ bots, onVictory }) {
  const { state, nextTurn } = useGameState(bots);

  const blind = BLIND_LEVELS[Math.min(Math.floor(state.round / 10), BLIND_LEVELS.length - 1)];

  const activePlayers = state.players.filter((p) => p.eliminatedAt === null);

  const winnerIds = new Set((state.roundResult ?? []).map((w) => w.id));

  const leadingIds = new Set();
  if (state.community.length >= 3 && state.phase !== "showdown") {
    const inPlay = activePlayers.filter((p) => !p.is_folded);
    if (inPlay.length > 1) {
      const evaluated = inPlay.map((p) => ({
        id: p.id,
        result: checkHands([...p.cards, ...state.community]),
      }));
      let best = null;
      for (const e of evaluated) {
        if (!best || compareHands(e.result, best) > 0) best = e.result;
      }
      for (const e of evaluated) {
        if (compareHands(e.result, best) === 0) leadingIds.add(e.id);
      }
    }
  }

  const playerProps = activePlayers.map((p) => {
    const isActive = state.players.indexOf(p) === state.lastActedIndex;
    const cards = p.is_folded ? [] : p.cards;
    const hand =
      state.community.length >= 3 && !p.is_folded
        ? checkHands([...p.cards, ...state.community])
        : null;

    return {
      cards,
      info: { name: p.config.name, avatar: p.config.image_url },
      action: p.lastAction,
      stack: p.funds,
      bet: p.current_bet,
      text: p.lastMessage,
      active: isActive && state.phase !== "showdown",
      won: state.phase === "showdown" && winnerIds.has(p.id),
      leading: leadingIds.has(p.id),
      enabled: !p.is_folded && !p.is_all_in,
      hand,
    };
  });

  return (
    <div className="Game">
      <GameTable cards={state.community} players={playerProps} />
      <div className="Game-Controls">
        <div className="Game-Info">
          <span className="Game-InfoItem">Раунд {state.round + 1}</span>
          <span className="Game-InfoItem Game-InfoItem--step">
            {STEP_NAMES[state.step]}
          </span>
          <span className="Game-InfoItem">
            SB: {blind[0]} / BB: {blind[1]}
          </span>
          <span className="Game-InfoItem">Банк: {state.pot}</span>
        </div>
        {state.phase === "showdown" && state.roundResult && (
          <div className="Game-Result">
            {state.roundResult.map((w) => (
              <span key={w.id} className="Game-ResultItem">
                {w.name} +{w.amount}
              </span>
            ))}
          </div>
        )}
        {state.phase === "gameOver" ? (
          <button className="Game-Btn Primary" onClick={() => onVictory(state.players)}>
            Экран победы
          </button>
        ) : (
          <button className="Game-Btn" onClick={nextTurn}>
            {state.phase === "showdown" ? "Следующий раунд →" : state.phase === "transition" ? `${NEXT_STEP_NAMES[state.step]} →` : "Следующий ход →"}
          </button>
        )}
      </div>
    </div>
  );
}
